import { Clickable, Col, Icon, Row } from 'components';
import { useOutsideClick } from 'core';
import { theme } from 'lib';
import React, { useRef } from 'react';
import styled from 'styled-components';

const reactions = [
  {
    icon: 'likeReact',
    type: 'like'
  },
  {
    icon: 'loveReact',
    type: 'love'
  },
  {
    icon: 'angryReact',
    type: 'angry'
  },
  {
    icon: 'careReact',
    type: 'care'
  },
  {
    icon: 'hahaReact',
    type: 'haha'
  },
  {
    icon: 'sadReact',
    type: 'sad'
  },
  {
    icon: 'wowReact',
    type: 'wow'
  }
];

const PostOption = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

// Always rendered, so picking a reaction does not shift the row; only its colour changes.
const SelectedDot = styled.span`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: ${(props) => (props.$active ? theme.GREY_70 : 'transparent')};
  transition: background-color 0.15s ease;
`;

const ReactionsContainer = styled.div`
  position: absolute;
  display: flex;
  top: -35px;
  left: -25px;
  flex-direction: row;
  background-color: #fff;
  align-items: center;
  padding: 16px;
  border-radius: 64px;
  justify-content: space-between;
  width: 352px;
  z-index: 2;
  elevation: 2;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.1);

  ${(props) =>
    props.post &&
    `
    top: -30px;
    left: -20px;
  `}

  ${(props) =>
    props.shoutout &&
    `
    top: -20px;
    left: -10px;
  `}
`;

const ReactToPost = ({
  shoutout,
  small,
  post,
  handleSubmit,
  reactionsVisible,
  setReactionsVisible,
  reaction
}) => {
  const reactionRef = useRef(null);

  useOutsideClick(reactionRef, handleOpenReactions);

  function handleOpenReactions() {
    setReactionsVisible(!reactionsVisible);
  }

  function getIcon() {
    return reactions.find((x) => x.type === reaction)?.icon || 'like';
  }

  if (post)
    return (
      <Row gap="10px">
        {reactions.map((x, i) => (
          <Clickable onClick={() => handleSubmit(x.type)} key={i}>
            <PostOption>
              <Icon type={x.icon} dimensions={24} />
              <SelectedDot $active={reaction === x.type} />
            </PostOption>
          </Clickable>
        ))}
      </Row>
    );

  return (
    <React.Fragment>
      {reactionsVisible && (
        <Col pos="relative">
          <Col pos="absolute">
            <ReactionsContainer
              post={post}
              shoutout={shoutout}
              ref={reactionRef}
              className="reactionsContainer"
            >
              {reactions.map((x, i) => (
                <Clickable
                  onClick={() => handleSubmit(x.type)}
                  key={i}
                  marg={i + 1 !== reactions.length && '0 5px 0 0'}
                >
                  <Icon type={x.icon} dimensions={32} />
                </Clickable>
              ))}
            </ReactionsContainer>
          </Col>
        </Col>
      )}

      <Clickable
        pad={post ? '0 13px 0 16px' : '0'}
        marg={post ? '0' : '0 5px 0 0'}
        onClick={handleOpenReactions}
        onClickUnused={() => handleSubmit(reaction || 'like')}
      >
        <Icon
          type={getIcon()}
          dimensions={small ? 16.5 : 22}
          col={small ? '#000' : theme.GREY_50}
        />
      </Clickable>
    </React.Fragment>
  );
};

export default ReactToPost;
